import { render, staticRenderFns } from "./ObtainedLicenseView.vue?vue&type=template&id=b5c6d2b6&"
import script from "./ObtainedLicenseView.vue?vue&type=script&lang=js&"
export * from "./ObtainedLicenseView.vue?vue&type=script&lang=js&"
import style0 from "./ObtainedLicenseView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports